var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crop",style:({height: _vm.height + 'px', width: _vm.width + 'px', overflow: 'hidden'})},[_c('img',{style:({height: 'auto', width: _vm.width + 'px'}),attrs:{"src":_vm.img,"alt":"Image missing"}})])}
var staticRenderFns = []

export { render, staticRenderFns }